function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import classnames from 'classnames';
import { setGlobalCssVariables } from '../../utils/css';
import { extractMatrixHeader, extractMatrixValue, findParentElement } from './utils';
var EMPTY_DATA_SOURCE = [];
var BLANK_CELL = {
  key: 'blank',
  type: 'blank',
  value: null
};

// tslint:disable-next-line:function-name
function MatrixView(props) {
  var _props$dataSource, _props$valueIndex, _props$labelIndex;

  var className = props.className,
      recordKey = props.recordKey,
      gutter = props.gutter,
      valueClassName = props.valueClassName,
      labelClassName = props.labelClassName;
  var rawData = (_props$dataSource = props.dataSource) !== null && _props$dataSource !== void 0 ? _props$dataSource : EMPTY_DATA_SOURCE;
  var valueIndex = (_props$valueIndex = props.valueIndex) !== null && _props$valueIndex !== void 0 ? _props$valueIndex : 'value';
  var labelIndex = (_props$labelIndex = props.labelIndex) !== null && _props$labelIndex !== void 0 ? _props$labelIndex : 'label'; // ============================ RecordKey ============================

  var getRecordKey = React.useMemo(function () {
    if (typeof recordKey === 'function') {
      return recordKey;
    }

    return function (record, index) {
      var _ref;

      return (_ref = record === null || record === void 0 ? void 0 : record[recordKey]) !== null && _ref !== void 0 ? _ref : index;
    };
  }, [recordKey]); // ============================ ValueClassName ============================

  var getValueClassName = React.useMemo(function () {
    if (typeof valueClassName === 'function') {
      return valueClassName;
    }

    return function () {
      return valueClassName;
    };
  }, [valueClassName]); // ============================ ValueClassName ============================

  var getLabelClassName = React.useMemo(function () {
    if (typeof labelClassName === 'function') {
      return labelClassName;
    }

    return function () {
      return labelClassName;
    };
  }, [labelClassName]); // ============================ renderLabel ============================

  var renderLabel = React.useMemo(function () {
    if (typeof props.labelRender === 'function') {
      return props.labelRender;
    }

    return function (value) {
      return value;
    };
  }, [props.labelRender]); // ============================ renderLabel ============================

  var renderValue = React.useMemo(function () {
    if (typeof props.valueRender === 'function') {
      return props.valueRender;
    }

    return function (values) {
      return values;
    };
  }, [props.valueRender]); // ============================= Gutter =============================

  var hasGutter = Number.isFinite(gutter);
  React.useEffect(function () {
    if (Number.isFinite(gutter) && gutter !== 0) {
      setGlobalCssVariables('matrix-view-gutter', "".concat(gutter / 2, "px"));
    }
  }, [gutter]); // ============================ Hovering Status Handlers ============================

  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentHoveringColIndex = _React$useState2[0],
      setCurrentHoveringColIndex = _React$useState2[1];

  var _React$useState3 = React.useState(undefined),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      currentHoveringRowIndex = _React$useState4[0],
      setCurrentHoveringRowIndex = _React$useState4[1];

  var handleCellMouseEvent = React.useCallback(function (ev, cell, rowIndex, colIndex) {
    var _ev$nativeEvent, _event$fromElement$da, _event$fromElement, _event$toElement$data, _event$toElement;

    var event = (_ev$nativeEvent = ev.nativeEvent) !== null && _ev$nativeEvent !== void 0 ? _ev$nativeEvent : ev;
    var eventType = ev.type;
    var fromElData = (_event$fromElement$da = (_event$fromElement = event.fromElement) === null || _event$fromElement === void 0 ? void 0 : _event$fromElement.dataset) !== null && _event$fromElement$da !== void 0 ? _event$fromElement$da : {};
    var toElData = (_event$toElement$data = (_event$toElement = event.toElement) === null || _event$toElement === void 0 ? void 0 : _event$toElement.dataset) !== null && _event$toElement$data !== void 0 ? _event$toElement$data : {};
    var rowParentMatch = findParentElement(event.toElement, function (el) {
      var _el$dataset;

      return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.rowIndex) === rowIndex.toString();
    });
    var newRowIndex = (fromElData === null || fromElData === void 0 ? void 0 : fromElData.rowIndex) !== (toElData === null || toElData === void 0 ? void 0 : toElData.rowIndex);
    var colParentMatch = findParentElement(event.toElement, function (el) {
      var _el$dataset2;

      return ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.colIndex) === colIndex.toString();
    });
    var newColIndex = (fromElData === null || fromElData === void 0 ? void 0 : fromElData.colIndex) !== (toElData === null || toElData === void 0 ? void 0 : toElData.colIndex);

    if (eventType === 'mouseenter') {
      if (rowParentMatch && newRowIndex) {
        setCurrentHoveringRowIndex(rowIndex);
      }

      if (colParentMatch && newColIndex) {
        setCurrentHoveringColIndex(colIndex);
      }
    } else if (eventType === 'mouseleave') {
      if (!rowParentMatch && newRowIndex) {
        setCurrentHoveringRowIndex(undefined);
      }

      if (!colParentMatch && newColIndex) {
        setCurrentHoveringColIndex(undefined);
      }
    }
  }, [currentHoveringRowIndex, currentHoveringColIndex]); // ============================ Matrix ============================

  var headerRow = [BLANK_CELL];
  var matrix = [headerRow];
  rawData.forEach(function (pRecord, colIndex) {
    var header = extractMatrixHeader(pRecord, colIndex, getRecordKey, getLabelClassName, renderLabel, labelIndex);
    headerRow.push(header);
    var row = [header];
    rawData.forEach(function (record, index) {
      row.push(extractMatrixValue([pRecord, record], [colIndex, index], getRecordKey, getValueClassName, renderValue, valueIndex));
    });
    matrix.push(row);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('matrix-view', className, _defineProperty({}, 'show-gutter', !!gutter))
  }, matrix.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement("div", {
      key: rowIndex,
      className: classnames('matrix-view-row')
    }, row.map(function (cell, colIndex) {
      var _classnames2;

      var dataKeys = {
        row: null,
        col: null,
        rowIndex: rowIndex,
        colIndex: colIndex
      };

      if ('dataKeys' in cell) {
        dataKeys = _objectSpread(_objectSpread({}, dataKeys), cell.dataKeys);
      }

      var isHeaderRow = rowIndex === 0;
      var isHeaderCol = colIndex === 0;
      var isRowHover = rowIndex === currentHoveringRowIndex;
      var isColHover = colIndex === currentHoveringColIndex;
      var isBlankCell = cell.type === 'blank';
      var isHeaderCell = cell.type === 'header';
      var isValueCell = cell.type === 'value';
      return /*#__PURE__*/React.createElement("div", {
        key: colIndex,
        "data-row-key": dataKeys.row,
        "data-row-index": dataKeys.rowIndex,
        "data-col-key": dataKeys.col,
        "data-col-index": dataKeys.colIndex,
        className: classnames('matrix-view-row-cell', "cell-type-".concat(cell.type), cell.className, (_classnames2 = {}, _defineProperty(_classnames2, 'matrix-view-row-header', isHeaderCol && isHeaderCell), _defineProperty(_classnames2, 'matrix-view-col-header', isHeaderRow && isHeaderCell), _defineProperty(_classnames2, 'matrix-view-row-hover', isRowHover && !isHeaderRow && !isBlankCell), _defineProperty(_classnames2, 'matrix-view-col-hover', isColHover && !isHeaderCol && !isBlankCell), _defineProperty(_classnames2, 'matrix-view-cell-hover', isRowHover && isColHover && isValueCell), _classnames2)),
        onMouseEnter: function onMouseEnter(ev) {
          return handleCellMouseEvent(ev, cell, rowIndex, colIndex);
        },
        onMouseLeave: function onMouseLeave(ev) {
          return handleCellMouseEvent(ev, cell, rowIndex, colIndex);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames('matrix-view-row-cell-value')
      }, cell.value));
    }));
  }));
}

export default MatrixView;